export const highlightText = (
  output: string,
  searchTerm: string,
  options: { jsx?: boolean; skipLinks?: boolean } = {},
): string | (string | JSX.Element)[] => {
  if (!searchTerm) return output;

  const { jsx = false, skipLinks = false } = options;
  const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const matchRegex = new RegExp(escapedTerm, "gi");
  const linkRanges = skipLinks ? getLinkRanges(output) : []; // get location of all links in the output text

  const result: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = matchRegex.exec(output)) !== null) {
    const start = match.index;
    const end = start + match[0].length;

    // the searchedTerm is within an identified link
    const inLink = skipLinks && linkRanges.some(
      ([linkStart, linkEnd]) => start >= linkStart && end <= linkEnd,
    );

    if (lastIndex < start) {
      result.push(output.slice(lastIndex, start));
    }

    result.push(
      jsx
        ? inLink
          ? match[0]
          : <mark key={start}>{match[0]}</mark>
        : inLink
          ? match[0]
          : `<mark>${match[0]}</mark>`,
    );

    lastIndex = end;

    // safety guard to prevent infinite loops if regex match zero-length strings
    if (matchRegex.lastIndex === start) {
      matchRegex.lastIndex++;
    }
  }

  if (lastIndex < output.length) {
    result.push(output.slice(lastIndex));
  }
  return jsx ? result : result.join("");
};

const getLinkRanges = (text: string): [number, number][] => {
  const ranges: [number, number][] = [];

  const urlRegex = /https?:\/\/[^\s<>"')]+/gi;

  let match: RegExpExecArray | null;

  while ((match = urlRegex.exec(text)) !== null) {
    ranges.push([match.index, match.index + match[0].length]);
  }

  return ranges;
};
